import { RelatorioInadimplentesItem } from "../typings";
import http from "infra/http";
import { RelatorioInadimplentesQueryParams } from "./../typings/index";
import { useInfiniteQuery } from "react-query";
import { PaginateResult } from "resources/types/shared";

function useRelatorioInadimplentesInfiniteScroll(
  params: RelatorioInadimplentesQueryParams
) {
  return useInfiniteQuery(
    [`/v1/relatorios/financeiro/inadimplentes/paginado`, params],
    async ({ pageParam }) => {
      const { data } = await http.get<
        PaginateResult<RelatorioInadimplentesItem>
      >("/v1/relatorios/financeiro/inadimplentes/paginado", {
        params: {
          ...params,
          page: pageParam ?? 1,
          cpf: params.cpf?.replace(/\W/g, ""),
        },
      });

      return data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage === lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}

export default useRelatorioInadimplentesInfiniteScroll;
